import axios from 'axios';
import React, {useEffect, useState, useRef, use } from 'react';
import '../styles/global.css';
import { useParams, useNavigate } from 'react-router-dom';
import Countdown from '../components/CountTime';

function Resultado() {
    const { idVotacao } = useParams();
    const navigate = useNavigate();
    const [pessoas, setPessoas] = useState(null);
    const [votacao, setVotacao] = useState(null);
    const [resultado, setResultado] = useState(null);
    const [registrados, setRegistrados] = useState(null);
    const [computados, setComputados] = useState(null);
    const [convocados, setConvocados] = useState(null);
    const [participantes, setParticipantes] = useState(null);
    const tokenAPI = "ae28b7ca-7db9-11ee-aa2d-fa163e6e2f00";

    function handleFecharModal() {
        window.history.back();
    }

    useEffect(() => {
        if (!idVotacao || parseInt(idVotacao) === 0) {
            navigate('/');
        }
    }, [idVotacao]);
    
    //CARREGAR PESSOAS
    useEffect(() => {
        axios
        .get(
            process.env.REACT_APP_API_URL + 
            '/routes.php?metodo=obterAssociadosAtivos',
            {
            headers: {
                "X-Access-Token" : tokenAPI,
                "Content-Type": "application/json; charset=UTF-8"
            }
        })
        .then(responseP => {
            if (responseP.data){
                setPessoas(responseP.data);
            } else {
                console.log('Nenhuma pessoa encontrada.');
            }
        })
        .catch(error => {
            console.error('Erro ao carregar pessoas: ', error.message);
        });
    }, [idVotacao]);
    //DADOS DA VOTAÇÃO
    useEffect(() => {
        const dados = {
            IdVotacao: idVotacao,
            IdPessoa: 0
        };
        //carregar dados da votação
        axios
        .post(
            process.env.REACT_APP_API_URL + 
            '/routes.php?metodo=obtemVotacoes', 
            JSON.stringify(dados),
            {
            headers: {
                "X-Access-Token" : tokenAPI,
                "Content-Type": "application/json; charset=UTF-8"
            }
        })
        .then(responseV => {
            if (responseV.data){
                setVotacao(responseV.data);
                if(!responseV.data || responseV.data.length === 0){
                    setVotacao(null);
                    navigate('/');
                }
            } else {
                console.log('Nenhuma votação encontrada.');
                setVotacao(null);
                navigate('/');
            }
        })
        .catch(error => {
            console.error('Erro ao carregar votação: ', error.message);
        });
    }, [idVotacao]);
    //CARREGAR RESULTADO DA VOTAÇÃO
    useEffect(() => {
        const dados = {
            IdVotacao: idVotacao,
        };
        axios
        .post(
            process.env.REACT_APP_API_URL + 
            '/routes.php?metodo=ObtemResultadoVotacao', 
            JSON.stringify(dados),
            {
            headers: {
                "X-Access-Token" : tokenAPI,
                "Content-Type": "application/json; charset=UTF-8"
            }
        })
        .then(responseR => {
            if (responseR.data){
                setResultado(responseR.data);
                if(!responseR.data || responseR.data.length === 0){
                    setResultado(null);
                    navigate('/');
                }
            } else {
                console.log('Nenhum resultado encontrado.');
            }
        })
        .catch(error => {
            console.error('Erro ao carregar resultado: ', error.message);
        });
    }, [idVotacao]);
    //CARREGAR VOTOS REGISTRADOS DA VOTAÇÃO
    useEffect(() => {
        const dados = {
            IdVotacao: idVotacao,
        };
        axios
        .post(
            process.env.REACT_APP_API_URL + 
            '/routes.php?metodo=ObtemVotosRegistrados', 
            dados,
            {
            headers: {
                "X-Access-Token" : tokenAPI,
                "Content-Type": "application/json; charset=UTF-8"
            }
        })
        .then(responseR => {
            if (responseR.data){
                setRegistrados(responseR.data);
                //em responseR.data preciso fazer um loop em cada registro e obter o dado IdPessoa e colocar em uma string com cada valor separado por ponto e vírgula e ao final alterar no votacao[0].vtcParticipantes
                if (responseR.data && responseR.data.length > 0) {
                    const idsParticipantes = responseR.data.map(registro => registro.IdPessoa).join(';');
                    votacao[0].vtcParticipantes = idsParticipantes;
                }
            } else {
                console.log('Nenhum voto registrado encontrado.');
            }
        })
        .catch(error => {
            console.error('Erro ao carregar votos registrados: ', error.message);
        });
    },[idVotacao]);
    //CARREGAR VOTOS COMPUTADOS DA VOTAÇÃO
    useEffect(() => {
        const dados = {
            IdVotacao: idVotacao,
        };
        axios
        .post(
            process.env.REACT_APP_API_URL + 
            '/routes.php?metodo=ObtemVotosComputados', 
            JSON.stringify(dados),
            {
            headers: {
                "X-Access-Token" : tokenAPI,
                "Content-Type": "application/json; charset=UTF-8"
            }
        })
        .then(responseC => {
            if (responseC.data){
                setComputados(responseC.data);
                //console.log(responseC.data);
            } else {
                console.log('Nenhum voto computado encontrado.');
            }
        })
        .catch(error => {
            console.error('Erro ao carregar votos computados: ', error.message);
        });
    }, [idVotacao]);

    //para popular a const convocados precisa fazer um filtro na const pessoas com os ids que estão em votavao.vtcConvocados
    if (votacao && votacao[0] && votacao[0].vtcConvocados && (!convocados || convocados === null)) {
        //console.log('Votação convocados:', votacao[0].vtcConvocados);
        if (pessoas && votacao[0] && votacao[0].vtcConvocados) {
            
            const idsConvocados = votacao[0].vtcConvocados.split(';');
            //.map(id => parseInt(id));
            const convocadosFiltrados = pessoas.filter(pessoa => idsConvocados.includes(String(pessoa.IdPessoa)));
            setConvocados(convocadosFiltrados);
        }
    }
    //na const registrados estão os votos registrados, preciso comparar com os convocados e participantes para ver quem votou e quem não votou
    //e identificar quem já votou para criar uma lista e sinalizar quem já votou
    // if (registrados && registrados.length > 0 && convocados && convocados.length > 0) {
    //     const idsQueVotaram = registrados.map(voto => String(voto.IdPessoa));
    //     setParticipantes(convocados.filter(convocado => idsQueVotaram.includes(String(convocado.IdPessoa))));
    // }
    //fazer o mesmo processo para participantes, do que foi feito para convocados
    if (votacao && votacao[0] && votacao[0].vtcParticipantes && (!participantes || participantes === null)) {
        //console.log('Votação participantes:', votacao[0].vtcParticipantes);
        if (pessoas && votacao[0] && votacao[0].vtcParticipantes) {
            const idsParticipantes = votacao[0].vtcParticipantes.split(';');
            const participantesFiltrados = pessoas.filter(pessoa => idsParticipantes.includes(String(pessoa.IdPessoa)));
            setParticipantes(participantesFiltrados);
        }
    }

    const [porcentagemParticipacao, setPorcentagemParticipacao] = useState(0);

    useEffect(() => {
        if (computados && computados.length > 0 && convocados && convocados.length > 0) {
            setPorcentagemParticipacao(((computados.length / convocados.length) * 100).toFixed(0));
        } else {
            setPorcentagemParticipacao(0);
        }
    }, [computados, convocados]);
    
    // console.log(idVotacao);
    // console.log(pessoas);
    // console.log(votacao);
    // console.log(registrados);
    // console.log(computados);
    // console.log(convocados);
    // console.log(participantes);

    // // Contagem regressiva até a data de encerramento
    // const Countdown = ({ targetDate }) => {
    //     // Função para calcular o tempo restante
    //     const calculateTimeLeft = () => {
    //         const difference = +new Date(targetDate) - +new Date();
    //         let timeLeft = {};

    //         if (difference > 0) {
    //             timeLeft = {
    //                 dias: Math.floor(difference / (1000 * 60 * 60 * 24)),
    //                 horas: Math.floor((difference / (1000 * 60 * 60)) % 24),
    //                 minutos: Math.floor((difference / 1000 / 60) % 60),
    //                 segundos: Math.floor((difference / 1000) % 60),
    //             };
    //         }
    //         return timeLeft;
    //     };

    //     const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

    //     useEffect(() => {
    //         // Atualiza o contador a cada 1 segundo (1000ms)
    //         const timer = setInterval(() => {
    //         setTimeLeft(calculateTimeLeft());
    //         }, 1000);

    //         // Limpa o intervalo quando o componente for desmontado
    //         return () => clearInterval(timer);
    //     }, [targetDate]);

    //     // Formata os números para sempre exibirem 2 dígitos (ex: 05 ao invés de 5)
    //     const formatNumber = (number) => {
    //         return String(number || 0).padStart(2, '0');
    //     };

    //     const timerComponents = [];

    //     // Verifica se ainda existe tempo restante
    //     if (Object.keys(timeLeft).length > 0) {
    //         return (
    //         <div style={styles.container}>
    //             <div style={styles.box}>
    //             <span style={styles.number}>{formatNumber(timeLeft.dias)}</span>
    //             <span style={styles.label}>Dias</span>
    //             </div>
    //             <span style={styles.colon}>:</span>
    //             <div style={styles.box}>
    //             <span style={styles.number}>{formatNumber(timeLeft.horas)}</span>
    //             <span style={styles.label}>Horas</span>
    //             </div>
    //             <span style={styles.colon}>:</span>
    //             <div style={styles.box}>
    //             <span style={styles.number}>{formatNumber(timeLeft.minutos)}</span>
    //             <span style={styles.label}>Minutos</span>
    //             </div>
    //             <span style={styles.colon}>:</span>
    //             <div style={styles.box}>
    //             <span style={styles.number}>{formatNumber(timeLeft.segundos)}</span>
    //             <span style={styles.label}>Segundos</span>
    //             </div>
    //         </div>
    //         );
    //     }

    //     return <div style={styles.finished}>O tempo acabou!</div>;
    // };

    // // Estilização simples embutida
    // const styles = {
    //     container: {
    //         display: 'flex',
    //         alignItems: 'center',
    //         justifyContent: 'center',
    //         fontFamily: 'sans-serif',
    //         gap: '10px',
    //     },
    //     box: {
    //         display: 'flex',
    //         flexDirection: 'column',
    //         alignItems: 'center',
    //         padding: '10px 15px',
    //         backgroundColor: '#1e293b',
    //         color: '#ffffff',
    //         borderRadius: '8px',
    //         minWidth: '60px',
    //     },
    //     number: {
    //         fontSize: '2rem',
    //         fontWeight: 'bold',
    //     },
    //     label: {
    //         fontSize: '0.75rem',
    //         textTransform: 'uppercase',
    //         color: '#94a3b8',
    //     },
    //     colon: {
    //         fontSize: '2rem',
    //         fontWeight: 'bold',
    //         color: '#1e293b',
    //     },
    //     finished: {
    //         fontSize: '1.5rem',
    //         fontWeight: 'bold',
    //         color: '#ef4444',
    //     },
    // };
    
    return (
        <div style={{ paddingBottom: '80px' }}>
            <main>
                <div>
                    {/* fechar */}
                    <div className="headerMain">
                        <div>
                            <button
                                className="buttonModalPadraoLaranja fs10"
                                onClick={handleFecharModal}>Fechar
                            </button>
                        </div>
                    </div>
                    {/* resumo resultado lista de pessoas */}
                    <div>
                        <div className="headerMain">
                            <label className='labelTitulo' >RESULTADO VOTAÇÃO</label>
                        </div>
                        <div className="fs12 text-align-center mb2">
                            <label><i><b>Resultado será divulgado por email após o encerramento.</b></i></label>
                        </div>
                        <div className="d-flex w100 flex-column tdAlignLeft pb4">
                            
                            <h3 className="fs10 text-align-center mb2"><b>Título:</b> {!votacao || !votacao[0] || !votacao[0].vtcTitulo ? 'Carregando votação...' : votacao[0].vtcTitulo}</h3>
                            <p><b><i>Estatísticas de Votos:</i></b></p>
                            <p><b><i>Convocados:</i></b> {!convocados || !convocados.length ? 'Carregando...' : convocados.length}</p>
                            <p><b><i>Registrados:</i></b> {registrados !== null ? registrados.length : 'Carregando...'}</p>
                            <p><b><i>Pendentes:</i></b> {!convocados || !convocados.length || !computados || !computados.length ? 'Carregando...' : convocados.length - computados.length}</p>
                            {/* <p><b><i>Computados:</i></b> {!computados || !computados.length ? 'Carregando...' : computados.length}</p> */}
                            <p className="fs12 text-align-center mb2"><b><i>% de participação:</i></b> {porcentagemParticipacao + '%'}</p>
                            <p className="fs12 text-align-center mb2"><b><i>Data de Encerramento:</i></b> {!votacao || !votacao[0] || !votacao[0].vtcDataFinal ? 'Carregando...' : new Date(votacao[0].vtcDataFinal).toLocaleDateString('pt-BR', {
                                            day: '2-digit',
                                            month: '2-digit',
                                            year: 'numeric',
                                            hour: '2-digit',
                                            minute: '2-digit'
                                            }).replace(',','')}</p>
                            {/* apresentar abaixo uma contagem regressiva até a data de encerramento */}
                            {/* <Countdown targetDate={!votacao || !votacao[0] || !votacao[0].vtcDataFinal ? null : new Date(votacao[0].vtcDataFinal)} /> */}
                            <Countdown targetDate={!votacao || !votacao[0] || !votacao[0].vtcDataFinal ? null : new Date(votacao[0].vtcDataFinal)} />
                        </div>
                        <div className="d-flex w100 flex-column tdAlignLeft pb4">
                            <hr className="w100" />
                                <div className="d-flex flex-row divForm">
                                    {/* Pessoas Convocadas */}
                                    <div className="w50 d-flex" style={{ verticalAlign: 'top', alignSelf: 'flex-start', alignItems: 'flex-start' }}>
                                        {/* lista das pessoas com sinalização de convocados */}
                                        <div className="w100">
                                            <div className="text-align-center divForm fs9 w100">
                                                <label>CONVOCADOS</label>
                                            </div>
                                            <div className="text-align-center divForm fs11 w100">
                                            {convocados && convocados.filter(pessoa => {
                                                if(parseInt(pessoa.pesStatus) === 1 && parseInt(pessoa.pesAssociado) === 1){
                                                    return pessoa;
                                                }
                                            }).length}
                                            </div>
                                            {/* lista de pessoas e convocados */}
                                            <div className="d-flex flex-column divForm w100 fs09" style={{ backgroundColor: '#979292', padding: '5px', padding: '5px', borderRadius: '5px' }}>
                                                {pessoas && pessoas.length > 0 
                                                && convocados && convocados.length > 0 
                                                ? pessoas
                                                .filter(pessoa => {
                                                    if(parseInt(pessoa.pesStatus) === 1 && parseInt(pessoa.pesAssociado) === 1){
                                                        return pessoa;
                                                    }
                                                })
                                                .map(pessoa => {
                                                    var estaConvocado =  convocados?.some((p) => String(p.IdPessoa) === String(pessoa.IdPessoa));
                                                    return (
                                                        <div key={pessoa.IdPessoa}
                                                            style={{ borderRadius: '5px', padding: '5px', cursor: 'pointer', width: '100%', backgroundColor: estaConvocado ? '#507455' : 'transparent' }} >
                                                            <div style={{ padding: '3px', textAlign: 'left', paddingTop: '5px' }}>
                                                                <b>{pessoa.pesNome}</b> 
                                                                {pessoa.pesEmail ? (
                                                                    <>
                                                                        <br /><span style={{ fontStyle: 'italic', fontSize: '0.8em' }}>{pessoa.pesEmail.split('@')[0]}</span>
                                                                        <br /><span style={{ fontStyle: 'italic', fontSize: '0.7em' }}>@{pessoa.pesEmail.split('@')[1]}</span>
                                                                    </>
                                                                ) : ''}
                                                            </div>
                                                            <div style={{ width: '100%', textAlign: 'right', paddingBottom: '5px' }}>
                                                                {estaConvocado && <span> (Convocado)</span>}
                                                            </div>
                                                        </div>
                                                    )
                                                })
                                                : <div>Nenhum convocado encontrado.</div>
                                            }
                                            </div>
                                        </div>
                                    </div>
                                    {/* Pessoas Pariticipantes */}
                                    <div className="w50 d-flex" style={{ verticalAlign: 'top', alignSelf: 'flex-start', alignItems: 'flex-start' }}>
                                        {/* lista das pessoas com sinalização de presença */}
                                        <div className="w100">
                                            <div className="text-align-center divForm fs9 w100">
                                                <label>PARTICIPANTES</label>
                                            </div>
                                            <div className="text-align-center divForm fs11 w100">
                                            {registrados && registrados.length}
                                            </div>
                                            {/* lista de votos */}
                                            <div className="d-flex flex-column divForm w100 fs09" style={{ backgroundColor: '#979292', padding: '5px', padding: '5px', borderRadius: '5px' }}>
                                                {convocados && convocados.length > 0 
                                                && participantes && participantes.length > 0 
                                                ? convocados
                                                    .filter(pessoa => {
                                                        if(parseInt(pessoa.pesStatus) === 1 && parseInt(pessoa.pesAssociado) === 1){
                                                            return pessoa;
                                                        }
                                                    })
                                                    .map(pessoa => {
                                                        const participante = registrados && registrados !== null && registrados !== undefined ? registrados?.some((p) => p.IdPessoa === pessoa.IdPessoa) : false;
                                                        return (
                                                            <div key={pessoa.IdPessoa}
                                                                style={{ borderRadius: '5px', border: '1px solid #bbb6b6', padding: '5px', cursor: 'pointer', width: '100%', color: registrados?.some((p) => p.IdPessoa === pessoa.IdPessoa) ? 'green' : 'red', backgroundColor: participante ? '#c8e6c9' : '#ffcdd2' }}>
                                                                <div style={{ padding: '3px', textAlign: 'left', paddingTop: '5px' }}>
                                                                    <b>{pessoa.pesNome}</b> 
                                                                    {pessoa.pesEmail ? (
                                                                    <>
                                                                        <br /><span style={{ fontStyle: 'italic', fontSize: '0.8em' }}>{pessoa.pesEmail.split('@')[0]}</span>
                                                                        <br /><span style={{ fontStyle: 'italic', fontSize: '0.7em' }}>@{pessoa.pesEmail.split('@')[1]}</span>
                                                                    </>
                                                                ) : ''}
                                                                </div>
                                                                <div style={{ width: '100%', textAlign: 'right', paddingBottom: '5px' }}>
                                                                    ({participante ? 'Votou' : 'Pendente'})
                                                                </div>
                                                            </div>
                                                        )
                                                    })
                                                : 
                                                <div>Nenhum voto encontrado.</div>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                        </div>
                    </div>
                    {/* fechar */}
                    <div className="headerMain">
                        <div>
                            <button
                                className="buttonModalPadraoLaranja fs10 clrWhite"
                                onClick={handleFecharModal}>Fechar
                            </button>
                        </div>
                    </div>
                </div>
            </main>
        </div>
    );
}

export default Resultado;